export default "__VITE_ASSET__ClLX$TtS__"